import React from "react";
import {
  Privacy_Policy_title,
  Privacy_Policy_image,
  half_circle_bg_image,
  half_circle_bg_image2,
  book_logo3,
  Proschool_logo,
} from "../../assets/images/images";
import { NavLink, useNavigate } from "react-router";
import HomeNavbar from "../home/components/HomeNavbar";
import { useDispatch, useSelector } from 'react-redux';

// Policy version metadata. COPPA requires fresh parental consent on material
// changes, which cannot be evidenced without a dated, versioned policy — so bump
// these whenever the text below changes materially.
const PRIVACY_POLICY_EFFECTIVE_DATE = "TO BE CONFIRMED BY LEGAL";
const PRIVACY_POLICY_LAST_UPDATED = "TO BE CONFIRMED BY LEGAL";
const PRIVACY_POLICY_VERSION = "1.0";

const PrivacyPolicySrds = () => {

  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);
  const subadmin_details = globalState.subadmin_details;
  const handleClick = (e) => {
    e.preventDefault(); // Prevent default link behavior

    // Navigate to the home page
    navigate("/");

    // Use setTimeout to delay the scroll to the specific section
    setTimeout(() => {
      const element = document.getElementById("revolution_sec_new");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Adjust the timeout as needed
  };

  return (
    <>
      <HomeNavbar />
      <div className="Terms-and-Conditions-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="Terms-and-Conditions-wrapper">
                <div className="Privacy_Policy_title">
                  <img src={Privacy_Policy_title} />
                </div>
                <div className="Terms-and-Conditions-image">
                  <img src={Privacy_Policy_image} />
                </div>
                <div className="Terms-and-Conditions-list-wrapper privacy-policy-content">
                  <div className="Terms-and-Conditions-list-foldre">
                    <p>
                      <strong>Effective Date:</strong> {PRIVACY_POLICY_EFFECTIVE_DATE} &nbsp;|&nbsp;{" "}
                      <strong>Last updated:</strong> {PRIVACY_POLICY_LAST_UPDATED} (v{PRIVACY_POLICY_VERSION})
                    </p>
                    <h2>Introduction</h2>
                    <p>
                      Saddle River Day School (“SRDS,” “School,” “we,” “us,” or “our”) provides its students, faculty, and staff with access to SRDS.ai (the Platform), a digital learning platform used to support instruction, assignment management, and classroom collaboration. SRDS.ai is built and operated on the School’s behalf by Arcot AI Solutions Private Limited, doing business as “Arcitech” (the Operator), a company registered in Mumbai, Maharashtra, India. This Privacy Policy explains what personal information is collected through the Platform, why, how it is used, stored, shared, and protected, and the rights available to you.
                    </p>
                    <p>
                      SRDS.ai serves Students — including children under 13 — who use the Platform to enroll in courses, complete assessments (including multiple-choice and voice-based assessments), submit assignments (including photo uploads), and use speech-to-text and voice-recording features; and Teachers, who create and manage courses, assignments, and assessments, and track student performance.
                    </p>
                    <p>
                      This Policy is anchored in the Children’s Online Privacy Protection Act (COPPA), 15 U.S.C. § 6501 et seq. and its implementing FTC Rule, 16 C.F.R. Part 312, and in New Jersey’s student online-education-services law, N.J.S.A. 56:8-215 et seq. (P.L. 2019, c. 494).
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>Scope of this Policy</h2>
                    <p>
                      This Privacy Policy applies only to personal information collected through SRDS.ai. It does not apply to other platforms operated by Arcitech or other Arcot Group companies, which maintain their own separate privacy policy.
                    </p>
                    <p>
                      SRDS has engaged the Operator to build and operate SRDS.ai to support the School’s instructional program. Personal Information collected through the Platform is governed by this Policy and by SRDS’s own enrollment agreement and parent handbook (if any). By accessing or using the Platform, you acknowledge that you have read and understood this Privacy Policy. If you are a parent or guardian, see Section 13 for the rights available to you.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>1. Definitions</h2>
                    <ul className="privacy-policy-bullet-list">
                      <li>
                        <strong>Child / Children:</strong> an individual under the age of 13, as defined under COPPA.
                      </li>
                      <li>
                        <strong>Operator:</strong> Arcitech (Arcot AI Solutions Private Limited), which builds and operates the Platform on the School’s behalf and is the operator of the Platform for COPPA purposes.
                      </li>
                      <li>
                        <strong>Parent / Guardian:</strong> a parent or legal guardian of a Student who is a Child, who may exercise the rights described in Section 13 on that Student’s behalf.
                      </li>
                      <li>
                        <strong>Personal Information / PI:</strong> information that identifies, relates to, describes, or could reasonably be linked, directly or indirectly, with a particular individual, including the categories described in Section 2.
                      </li>
                      <li>
                        <strong>Sensitive Personal Information:</strong> we treat Student voice recordings, photographs, and assessment responses as sensitive given their connection to children, and the amended COPPA Rule (16 C.F.R. Part 312) separately treats biometric identifiers as personal information requiring heightened care.
                      </li>
                      <li>
                        <strong>Service Provider:</strong> a third party that processes Personal Information on our or the Operator’s behalf, as described in Section 6.
                      </li>
                      <li>
                        <strong>Student:</strong> an individual, including a Child, who uses the Platform to enroll in and complete courses, assessments, and assignments.
                      </li>
                      <li>
                        <strong>Teacher:</strong> an individual who uses the Platform to create and manage courses, assignments, and assessments, and to review Student performance.
                      </li>
                      <li>
                        <strong>Platform:</strong> SRDS.ai and its associated web pages, applications, and digital interfaces.
                      </li>
                    </ul>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>2. Information We Collect</h2>
                    <p>
                      We collect only the personal information reasonably necessary for a child to participate in the service, and we do not condition a child’s participation on providing information that is not reasonably necessary.
                    </p>
                    <p>We collect Personal Information through the following touchpoints:</p>
                    <div className="privacy-policy-table-wrapper">
                      <table className="privacy-policy-table">
                        <thead>
                          <tr>
                            <th>Touchpoint</th>
                            <th>Personal Information Collected</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Student registration &amp; login (Google sign-in or verification code), and profile setup</td>
                            <td>At registration: school email address. During profile setup: Student name, grade, date of birth, city and state, and language preference.</td>
                          </tr>
                          <tr>
                            <td>Student course activity</td>
                            <td>Courses and subjects enrolled in; assessment responses, including voice-based assessments; assignment submissions, including photo/image uploads; voice recordings and speech-to-text inputs generated during assessments or assignments.</td>
                          </tr>
                          <tr>
                            <td>Teacher registration &amp; profile</td>
                            <td>Name, email address, subjects taught, and an optional profile description.</td>
                          </tr>
                          <tr>
                            <td>Teacher course content &amp; files</td>
                            <td>Uploaded course materials and files.</td>
                          </tr>
                          <tr>
                            <td>Teacher–Student interaction</td>
                            <td>Messages sent via the Platform's messaging feature; grades, scores, notes, and feedback a Teacher enters about a Student.</td>
                          </tr>
                          <tr>
                            <td>Using the Platform generally</td>
                            <td>Technical and telemetry data collected automatically (IP address, browser/device type, referring/exit pages), gathered via cookies and server logs.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p>
                      Student photographs, voice recordings, and assessment responses are collected only for the educational purposes described in Section 3, and are not used for advertising, profiling, or marketing.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>3. How We Use Your Information</h2>
                    <ul className="privacy-policy-bullet-list">
                      <li>Create and manage Student and Teacher accounts.</li>
                      <li>Enable Teachers to create, deliver, and grade courses, assignments, and assessments.</li>
                      <li>Enable Students to enroll in courses and complete assessments and assignments, including via voice recording and speech-to-text.</li>
                      <li>Track Student learning progress and performance, and provide Teachers with tools to review it and provide feedback.</li>
                      <li>Operate, secure, and improve the Platform, including detecting and preventing fraud and abuse.</li>
                      <li>Comply with applicable law, and establish, exercise, or defend legal claims.</li>
                    </ul>
                    <p>
                      <strong>Use of Artificial Intelligence:</strong> The Platform includes an AI assistant (visible as a chat widget) and an “AI Feedback” feature that generates performance-insight suggestions for Teachers based on Student assessment data. These features are built and operated by the Operator, and they send the content you submit to them (for example, your messages to the AI assistant, or the assessment data used to generate feedback) to third-party large language model providers — currently OpenAI and Anthropic — which process that content solely to return the response and act on the Operator’s instructions. Under the commercial API terms applicable to this use, neither provider uses that content to train its models, and Student or Teacher personal information is not used to train any AI model, ours or a third party’s. Each provider retains the submitted content for no longer than 30 days, for abuse and misuse monitoring only, and deletes it after that period unless a longer period is required by law.
                    </p>
                    <p>
                      <strong>No Behavioral Use of Children’s Data:</strong> Student data, including assessment responses, photos, and voice recordings, is used solely to provide educational services and is not used for advertising, behavioral profiling, or marketing.
                    </p>
                    <p>
                      <strong>Teacher-in-the-Loop:</strong> AI Feedback and similar analytics are a tool for the Teacher’s review, not a replacement for the Teacher’s own grading or evaluation judgment.
                    </p>
                    <p>
                      <strong>Voice Data:</strong> Voice recordings and speech-to-text inputs are processed to support voice-based assessments and accessibility. They are not used to create voiceprints or any other biometric identifier.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>4. Basis for Collection and Processing</h2>
                    <p>
                      <strong>COPPA:</strong> Verifiable parental consent is obtained before collecting personal information from a Child under 13. Because SRDS has a pre-existing trust relationship with parents and reviews the Operator’s data practices for the School’s educational purpose, SRDS provides this consent on behalf of parents, consistent with FTC guidance recognizing schools as intermediaries for COPPA consent in this context — see Section 13.
                    </p>
                    <p>
                      <strong>New Jersey Law:</strong> The Operator’s processing of Student data is intended to comply with New Jersey’s online education services and student records law, N.J.S.A. 56:8-215 et seq. (P.L. 2019, c. 494), including its restrictions on targeted advertising, sale of student data, and profiling beyond K-12 educational purposes, and its requirement to delete data on request or at the end of service.
                    </p>
                    <p>
                      <strong>Teacher accounts and other adult Users:</strong> your consent to this Policy, and our legitimate interest in operating and securing the Platform.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>5. Cookies and Tracking Technologies</h2>
                    <p>
                      The Platform uses cookies and similar technologies for authentication (keeping Students and Teachers logged in), user preferences (such as language), and fraud prevention and security. The Platform does not run third-party analytics or advertising tags, and cookies are not used for targeted advertising or marketing. You may manage, disable, or delete cookies through your browser or device settings at any time; disabling authentication cookies will prevent you from remaining logged in.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>6. Sharing of Personal Information</h2>
                    <p>
                      We do not sell Personal Information, and do not share it for cross-context behavioral advertising. Student course activity, assessment responses, assignment submissions, and progress data are visible to the Teacher(s) responsible for that Student’s course(s) and to authorized SRDS administrators, for educational evaluation and guidance purposes.
                    </p>
                    <p>We may also share Personal Information with:</p>
                    <ul className="privacy-policy-bullet-list">
                      <li>The Operator (Arcitech) and its personnel, who need access to build, host, maintain, and support the Platform.</li>
                      <li>Google, for Google sign-in and related integrations, where used.</li>
                      <li>Cloud hosting and web-infrastructure providers.</li>
                      <li>Legal and regulatory authorities, where required by law, or to establish, exercise, or defend legal claims.</li>
                      <li>A successor entity, in the event of a merger, acquisition, or sale of assets, which will remain bound by this Policy or a materially similar policy.</li>
                    </ul>
                    <p>
                      We require every Service Provider to protect Personal Information to a standard consistent with this Policy and applicable law.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>7. International Data Processing</h2>
                    <p>
                      The Platform is directed at users in the United States. The Operator, Arcitech, is based in Mumbai, Maharashtra, India, and its personnel may access, host, and support the Platform from India in connection with providing these services to SRDS. We require the Operator to protect Personal Information consistently with this Policy and applicable law regardless of where its personnel are located.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>8. Retention of Personal Information</h2>
                    <p>
                      We keep Student and Teacher information only as long as reasonably necessary for the purpose it was collected, consistent with the amended COPPA Rule (16 C.F.R. § 312.10), as follows:
                    </p>
                    <div className="privacy-policy-table-wrapper">
                      <table className="privacy-policy-table">
                        <thead>
                          <tr>
                            <th>Data Category</th>
                            <th>Retention Period</th>
                            <th>Basis</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Account &amp; profile data (student name, grade, date of birth, school email, city/state, language preference)</td>
                            <td>Duration of active enrollment, plus up to 12 months after account closure or graduation</td>
                            <td>Matches the practical administrative window (transfers, re-enrollment, dispute resolution); avoids indefinite retention untethered from actual need</td>
                          </tr>
                          <tr>
                            <td>Profile photo (optional field)</td>
                            <td>Same as account data above; deleted on account closure</td>
                            <td>Optional field with no distinct educational necessity beyond the active enrollment period</td>
                          </tr>
                          <tr>
                            <td>Assignment submissions (documents, PDFs, spreadsheets, images of student work)</td>
                            <td>Through the end of the school term/academic year in which submitted, then deleted or returned to SRDS</td>
                            <td>Matches the instructional purpose (grading and feedback); no platform-side need to retain past the grading window</td>
                          </tr>
                          <tr>
                            <td>Audio recordings (Record button submissions)</td>
                            <td>Until grading and any grade-appeal period for that assignment closes, not to exceed the end of the academic year</td>
                            <td>Voice recordings are treated as sensitive; retained only as long as needed to grade and give feedback</td>
                          </tr>
                          <tr>
                            <td>Speech-to-text: raw audio</td>
                            <td>Not retained — deleted immediately after transcription</td>
                            <td>Minimizes retention of sensitive audio beyond what is needed to produce the text</td>
                          </tr>
                          <tr>
                            <td>Technical/login data (device or IP identifiers, security and access logs)</td>
                            <td>12 months</td>
                            <td>Consistent with general industry practice for security and fraud-prevention logs</td>
                          </tr>
                          <tr>
                            <td>Any data subject to an active dispute, legal hold, or specific SRDS instruction</td>
                            <td>Retained only as long as the dispute, hold, or instruction requires</td>
                            <td>Standard override for exceptional circumstances</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p className="privacy-policy-table-note">
                      If SRDS’s own recordkeeping practices require it to retain specific records (such as final grades) for longer than the periods above, that is a School recordkeeping matter separate from what is stored on the Platform itself; SRDS may export what it needs before the Operator deletes platform-side data.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>9. Data Security</h2>
                    <p>
                      The Operator implements technical, organizational, and physical security measures designed to protect Personal Information against unauthorized access, disclosure, alteration, loss, or destruction, including encryption of data in transit and, where appropriate, at rest; access controls, so that only the Teacher(s) responsible for a Student’s course and authorized SRDS administrators can access that Student’s data; and maintenance of security and access logs. No method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
                    </p>
                    <p>
                      In the event of a security breach affecting Personal Information, we will comply with applicable state data breach notification laws. Where New Jersey law applies, this means notifying the New Jersey Division of State Police first, and then notifying affected parents/guardians, in that order. Any breach involving Student photos, voice recordings, or assessment data will be treated as high priority.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>10. Your Rights</h2>
                    <ul className="privacy-policy-bullet-list">
                      <li>
                        <strong>Right to Know / Access</strong> — request a summary of the Personal Information we hold about you or your child.
                      </li>
                      <li>
                        <strong>Right to Correct</strong> — request correction of inaccurate Personal Information.
                      </li>
                      <li>
                        <strong>Right to Delete</strong> — request deletion of Personal Information, subject to SRDS’s legitimate educational recordkeeping needs.
                      </li>
                      <li>
                        <strong>Parental Rights (COPPA)</strong> — see Section 13 for the specific rights available to parents/guardians of a Child Student.
                      </li>
                    </ul>
                    <p>
                      To exercise any of these rights, contact us using the details in Section 15. We may need to verify your identity, or your relationship to a Child Student, before actioning a request.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>11. Your Obligations</h2>
                    <ul className="privacy-policy-bullet-list">
                      <li>Provide accurate, current, and complete information.</li>
                      <li>(For Teachers) use Student data solely for legitimate educational purposes, consistent with this Policy.</li>
                      <li>Not impersonate any person or misrepresent your identity, age, or affiliation.</li>
                      <li>Not attempt to access another user’s account or Personal Information without authorization.</li>
                      <li>Promptly notify us of any suspected unauthorized access or security incident concerning your information.</li>
                    </ul>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>12. Complaints and Requests</h2>
                    <p>
                      If you have a complaint or request regarding the handling of Personal Information, please contact us using the details in Section 15. If you are not satisfied with our response, you may contact the Federal Trade Commission (for COPPA-related concerns) or the New Jersey Attorney General’s office (for New Jersey student-data-privacy concerns).
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>13. Children’s Privacy</h2>
                    <p>
                      The Platform is intended for use by Students, including Children under 13, and this Section describes how we comply with COPPA.
                    </p>
                    <ul className="privacy-policy-bullet-list">
                      <li>
                        <strong>Consent:</strong> SRDS provides consent on behalf of parents/guardians for Student use of the Platform for the School’s educational purposes, consistent with FTC guidance recognizing schools as intermediaries for COPPA consent in this context, provided Student data is used solely for that educational purpose.
                      </li>
                      <li>
                        <strong>What We Collect From Children:</strong> name, grade, date of birth, school email, city/state, language preference, assessment responses, assignment submissions (including photos), and voice recordings/speech-to-text inputs, as described in Section 2.
                      </li>
                      <li>
                        <strong>No Advertising or Profiling:</strong> Children’s personal information is used solely to provide educational services and is not used for advertising, behavioral profiling, or marketing.
                      </li>
                      <li>
                        <strong>Parental Rights:</strong> A parent/guardian may, at any time, review the personal information we have collected from their child, request that we delete that information, refuse to permit further collection or use of their child’s information, and revoke any previously given consent — by contacting us using the details in Section 15. We will verify the requester’s identity and respond within 14 days. If consent is revoked, we will delete the child’s personal information from active systems and backups within 20–30 days, unless retention is required by law.
                      </li>
                    </ul>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>14. Third-Party Integrations</h2>
                    <p>
                      The Platform may integrate with Google Drive, where used by a School administrator or Teacher. When you choose to import a file, the Platform opens Google’s own file picker so that you select the files yourself from your Drive. We receive only the files you select, together with the file and folder names needed to display your Drive contents in that picker; we do not otherwise browse, read, or store the rest of your Drive.
                    </p>
                    <p>
                      The Platform also relies on the following third-party service providers, each of which processes Personal Information only as needed to provide its service to us: <strong>Amazon Web Services</strong> (cloud hosting and storage of uploaded files); <strong>Google Firebase</strong> (sign-in, which stores the email address used to identify the account); <strong>OpenAI</strong> and <strong>Anthropic</strong> (the large language models behind the AI assistant and AI Feedback features described in Section 3, each retaining submitted content for no longer than 30 days before deleting it); and <strong>Zoho Desk</strong> (support ticketing, where you contact us for help). We do not control, and are not responsible for, the privacy practices of these or any other third party.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>15. Contact Us</h2>
                    <p>
                      For questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact:
                    </p>
                    <div className="privacy-policy-table-wrapper">
                      <table className="privacy-policy-table">
                        <tbody>
                          <tr>
                            <th>Privacy Contact (School)</th>
                            <td>
                              Saddle River Day School, 147 Chestnut Ridge Rd, Saddle River, NJ 07458 | Phone:{" "}
                              <a href="tel:+12013274050" className="policies-link">+1 201-327-4050</a> | Email:{" "}
                              <a href="mailto:privacy@saddleriverday.org" className="policies-link">kmerges@saddleriverday.org</a>
                            </td>
                          </tr>
                          <tr>
                            <th>Platform Operator</th>
                            <td>
                              Arcot AI Solutions Private Limited (“Arcitech”), A-806, 2nd Floor, Trade Link, Kamala Mills, Lower Parel, Mumbai, Maharashtra 400013, India
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>16. Changes to this Privacy Policy</h2>
                    <p>
                      We may update this Privacy Policy from time to time to reflect changes in our practices or applicable law. Material changes will be highlighted on this page, and, where required under COPPA for material changes affecting previously collected Children’s data, we will seek fresh consent from parents/guardians.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>17. Governing Law and Jurisdiction</h2>
                    <p>
                      This Privacy Policy is governed by the laws of the State of New Jersey, without prejudice to any mandatory consumer-protection rights you may have under the law of your own state.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>18. Consent</h2>
                    <p>
                      By accessing or using the Platform, you (or, for a Child Student, your parent/guardian) acknowledge that you have read, understood, and agree to this Privacy Policy.
                    </p>
                  </div>
                  <div className="Terms-and-Conditions-list-foldre">
                    <h2>19. Disclaimer</h2>
                    <p>
                      While we implement reasonable security measures, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security. You acknowledge and accept the inherent risks of providing personal information online, to the fullest extent permitted by applicable law.
                    </p>
                  </div>
                </div>
                <div className="half-circle-bg-image">
                  <img src={half_circle_bg_image} />
                </div>
                <div className="half-circle-bg-image2">
                  <img src={half_circle_bg_image2} />
                </div>
                <div className="book-logo3">
                  <img src={book_logo3} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-section" id="footer-section">
        <div className="footer-wraper">
          <div className="footer-link-folder">
            <p>Saddle River Day School</p>
          </div>
          <div className="footer-Quick-Links-folder">
            <h2>Quick Links</h2>
            <ul className="footer-Quick-Links">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li>
                <NavLink to="/about">About Us</NavLink>
              </li>
              <li>
                <NavLink to="/privacy-policy">Privacy Policy</NavLink>
              </li>
            </ul>
          </div>
          <div className="footer-Quick-Links-folder">
            <h2>Contact</h2>
            <div className="footer-contact">
              <div className="footer-contact-folder">

                <a><i class="fa-solid fa-phone"></i></a>
                <span><a href="tel:+1 201-327-4050">+1 201-327-4050</a></span>
              </div>
              <div className="footer-contact-folder">
                <a><i class="fa-solid fa-envelope"></i></a>
                <a href="mailto: noreply@saddleriverday.org">kmerges@saddleriverday.org</a>
              </div>
              <div className="footer-contact-folder">
                <a><i class="fa-solid fa-location-dot"></i></a>
                <a href="https://www.google.com/maps/place/Saddle+River+Day+School/@41.0307394,-74.0880125,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2e436c9e7ef3b:0xf060c34a65b01898!8m2!3d41.0307394!4d-74.0854376!16zL20vMGRkYzZ5?entry=ttu" target="_blank">Saddle River Day School, 147 Chestnut Ridge Road, Saddle River, NJ 07458​​.</a>
              </div>
            </div>
          </div>
          <div className='footer-get-in-touch-folder'>
            <span>Get in touch</span>
            <div className='footer-social-link-folder'>
              <a href='https://www.facebook.com/saddleriverdayschool' target="_blank"><i className="fa-brands fa-facebook"></i></a>
              <a href='https://twitter.com/srDSrebels' target="_blank"><i class="fa-brands fa-x-twitter"></i></a>
              <a href='https://www.instagram.com/saddleriverday/' target="_blank"><i className="fa-brands fa-instagram"></i></a>
              <a href='https://vimeo.com/srds' target="_blank"><i class="fa-brands fa-vimeo-v"></i></a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicySrds;
